export default __webpack_public_path__ + "static/media/navigate_next_black.466cbb54.svg";